// removed by extract-text-webpack-plugin
module.exports = {"button":"_1c6a40424b_src-comparableSales-_FreezeStateButton_button"};


//////////////////
// WEBPACK FOOTER
// ./src/comparableSales/FreezeStateButton.css
// module id = 1672
// module chunks = 0